import React from 'react';

import { Product, Slug } from '../../../models/domain/interfaces';
import { StyledContentWrapper } from './SliderProductForNews.style';
import { productSliderConfigs } from '../../../utils/carousels';
import ProductCarouselForNews from '../../../components/carousel/carousel-products-for-news/CarouselProductsForNews';
import { getProductById, getProductsByCategoryId } from '../../../services/dwh';
import { shrinkProduct } from '../../../utils/shrink';
import { imageMapper } from '../../../utils/products';
import {
  internationalizationToLanguages,
  multipleToSingleSpace,
} from 'corporate-utils';
import { defaultInternationalization, defaultLanguage } from 'corporate-types';
import { urlFromCategoriesIds } from '../../../utils/urls';
import { getAvailableStringFromCategoryByLocale } from '../../../utils/categories';
import { SliderProductsForNews } from '../../../models/auto-generated-strapi-types/types/components/SliderProductsForNews';

interface SliderProductForNewsProps extends SliderProductsForNews {
  products: Product[];
  translations: any;
}

const SliderProductForNews: React.FC<{
  data: SliderProductForNewsProps;
  translations: any;
  isPrerenderRequest: boolean;
}> = ({
  data,
  isPrerenderRequest,
}: {
  data: SliderProductForNewsProps;
  isPrerenderRequest: boolean;
}) => {
  const { products, translations, sliderConfigs, title, totalNews } =
    data || {};

  const prods = products.slice(0, totalNews || 6);

  return (
    <>
      {products.length > 0 && (
        <StyledContentWrapper>
          <ProductCarouselForNews
            translations={translations}
            title={title || ''}
            products={prods}
            sliderConfigs={sliderConfigs ?? productSliderConfigs}
            isPrerenderRequest={isPrerenderRequest}
          />
        </StyledContentWrapper>
      )}
    </>
  );
};

export default SliderProductForNews;

export const getServerSideProps = async (
  section: any,
  translations: any,
  slugAnalyzed: Slug
) => {
  let finalProducts: any[] = [];

  if (section?.categoryList && section?.categoryList?.length > 0) {
    let products = [];
    for (const category of section?.categoryList) {
      products = (
        await getProductsByCategoryId(
          category?.idDwh,
          1,
          10,
          'rand',
          slugAnalyzed?.locale
        )
      )?.items;
      if (products && products.length > 0)
        products.map((p: Product) => finalProducts.push(p));
    }
  }

  if (section?.productList && section?.productList?.length > 0) {
    let prod = undefined;
    for (const product of section?.productList) {
      prod = await getProductById(product?.sku, slugAnalyzed.locale);
      if (product) finalProducts.push(prod);
    }
  }
  finalProducts = finalProducts?.map?.(
    (product: Product) => (product = shrinkProduct(product))
  );

  finalProducts = finalProducts?.map((product: Product) =>
    imageMapper(
      product,
      internationalizationToLanguages(
        slugAnalyzed?.locale || defaultInternationalization,
        slugAnalyzed?.slug as string
      ) || defaultLanguage
    )
  );

  section.products = finalProducts
    ?.map?.((product) => ({
      category: getAvailableStringFromCategoryByLocale(
        product.categoriesCalculatedInfo?.[0]?.[0],
        slugAnalyzed?.locale,
        'packages/corporate-ui/src/utils/dwh.ts'
      ),
      name: multipleToSingleSpace(product?.nameFather || ''),
      image: `${process.env?.IMAGE_URL_BASE_PATH_BIG}${product?.cover}`,
      link:
        '/' +
        slugAnalyzed.locale +
        (urlFromCategoriesIds(
          slugAnalyzed?.megamenuLinks,
          product?.categoriesCalculated,
          slugAnalyzed?.locale,
          'product',
          { sku: product?.sku, nameFather: product?.nameFather },
          'packages/corporate-ui/src/utils/dwh.ts 2'
        ) || '/'),
      categoriesCalculatedInfo: product?.categoriesCalculatedInfo,
    }))
    .map((value) => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value);
};
